module.exports = __webpack_public_path__ + "ev-user.png?fb7b013a3d267085ff4bfcbe2f78ea76";